module.exports = __webpack_public_path__ + "img/top-logo-5.ef29372d.png";